import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
// import { Personal } from '../models/personal';
// import {Familiar} from '../models/familiar';
import { MatPaginator,MatDialog, MatSort } from '@angular/material';
import { DataService } from '../../utils/data.service';
import { BitacoraClienteAddEditComponent } from './agregar-editar/bitacoraCliente-addedit.component';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
@Component({
  selector: 'my-bitacoracliente',
  styleUrls: [],
  templateUrl: 'bitacoraCliente.component.html',
  providers: [generalService]
})


export class BitacoraClienteComponent implements OnInit {
displayedColumns = ['acciones', 'CREATION_DATE', 'TYPE_DESC' , 'COMMENTS'];
dataSource: DataSourceGrid | null;
public datosBitacora: Array<any>;
customer_id: string;

 @ViewChild(MatPaginator) paginator: MatPaginator;
 @ViewChild(MatSort) sort: MatSort;

   constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _generalService: generalService,
    public dataService: DataService,
    public dialog: MatDialog
    ) {
    this.customer_id = (this.route.snapshot.paramMap.get('id'));
    this.datosBitacora = new Array();
  }

  ngOnInit() {
    this.getBitacora(this.customer_id);
  }

  getBitacora(id: any) {
    this._generalService.metodoCall(`bitacora/consultarBitacorasCliente/${id}`).subscribe(
      (result) => {
        this.datosBitacora = JSON.parse(result);
        this.dataSource = new DataSourceGrid(this.datosBitacora, this.paginator, this.sort);
        if (this.datosBitacora.length <= 0) {
            $('#tableBitacora .mat-row').remove('.mat-row');
          }
      },
      (error) => {
        let errorMsj =  error as any;
        console.log(errorMsj);
      }
    );
  }

  agregar() {
    this.dataService.isUpdate = false;
    const dialogRef = this.dialog.open(BitacoraClienteAddEditComponent, {disableClose: true, width: '100%', maxWidth: '50%'});
    this.dataService.idCliente = this.customer_id;
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
       // this._generalService.toastCall("El registro se agregó exitosamente!");
       this.ngOnInit();
    });
  }

  editar(idBitacora) {
    this.dataService.id = idBitacora;
    this.dataService.isUpdate = true;
    this.dataService.idCliente = this.customer_id;
    const dialogRef = this.dialog.open(BitacoraClienteAddEditComponent, {disableClose: true, width: '100%', maxWidth: '50%'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      // this._generalService.toastCall("El registro se actualizó exitosamente!");
      this.ngOnInit();
    });
  }

  eliminarConfirm(data: any) {
    const eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {

          this._generalService.toastCall('El registro se eliminó exitosamente!');
          this.ngOnInit();

      }
    );
    const bitacora: any = new Object();
    bitacora.TRANSACTION_ID = data.TRANSACTION_ID;
    this._generalService.modal(eliminarHttp, 'confirm', '¿Desea eliminar el registro ' + data.TYPE_DESC + '?', 'bitacora/eliminarBitacoraCliente/', bitacora);
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/bitacora/bitacoraCliente.component.ts